import { render, staticRenderFns } from "./subEntities.vue?vue&type=template&id=4d6d995e&"
import script from "./subEntities.vue?vue&type=script&lang=js&"
export * from "./subEntities.vue?vue&type=script&lang=js&"
import style0 from "./subEntities.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports